<template>
  <div v-if="contentLoader" class="contentLoaderWrap">
    <div :class="message ? 'content-loading' : 'circle-loading'">
      <vsg-progress card type="circular" size="large" indeterminate> </vsg-progress>
    </div>
    <div v-if="message" class="center" :key="message">
      <jha-slider>
        <jha-slider-content :focusedPane="'messageTransition'">
          <jha-slider-pane messageTransition focus>
            <label class="content-message"> {{ message }} </label>
          </jha-slider-pane>
        </jha-slider-content>
      </jha-slider>
    </div>
  </div>
</template>
<script lang="ts">
import "@banno/jha-wc/src/sliders/jha-slider/jha-slider.js";
import "@banno/jha-wc/src/sliders/jha-slider-content/jha-slider-content.js";
import "@banno/jha-wc/src/sliders/jha-slider-pane/jha-slider-pane.js";
import { defineComponent } from "vue";
import {VsgProgress} from "@jack-henry/jha-vue-components";
export default defineComponent({
  name: "bltContentloader",
  components: {VsgProgress},
  data: () => ({
    timer: null as any,
    message: ""
  }),
  props: {
    contentLoader: { type: Boolean },
    contents: {
      default: () => []
    }
  },
  mounted: function () {
    // This functionality will work when contents array is paased to this component.
    // Below changes are made to support the CIP Preloader with messages.
    if (this.contents && this.contents.length > 0) {
      setTimeout(() => {
        this.message = this.contents[0];
      }, 1000);
    }
    if (this.contents && this.contents.length > 1) {
      let index = 1;
      this.timer = setInterval(() => {
        this.message = this.contents[index++];
        if (index === this.contents.length) clearInterval(this.timer);
      }, 5000);
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
});
</script>
<style scoped>
.content-message {
  font-size: 14px;
  color: var(--body-text-secondary-color);
}
.center {
  align-items: center;
  text-align: center;
  padding-top: 16px;
}

jha-progress {
  margin: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
}

.contentLoaderWrap{
  position: absolute;
  z-index: 100;
  height: 100%;
  width: 100%;
  background: var(--jha-card-background-color, var(--jha-component-background-color, #fff));
  border-radius: var(--jh-border-radius-300);
}
</style>
